import { Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as events from '../../../events';
import * as actions from '../../../state';
import styles from './styles.module.css';
import officeLogo from './office-logo.svg';

const messages = defineMessages({
  LOG_IN_WITH_OFFICE: {
    id: 'LOG_IN_WITH_OFFICE',
    defaultMessage: 'Log in with Office 365',
  },
});

let msalInstance;

function OfficeSso() {
  const dispatch = useDispatch();

  const officeSsoClientId = useSelector(
    (state) => actions.selectConfig(state, `PORTAL_LOGIN_OFFICE_SSO_CLIENT_ID_${window.location.hostname}`)
      || actions.selectConfig(state, 'PORTAL_LOGIN_OFFICE_SSO_CLIENT_ID'),
  );

  const initOffice = () => {
    const msalConfig = {
      auth: {
        clientId: officeSsoClientId,
        // eslint-disable-next-line no-restricted-globals
        redirectUri: `${location.origin}/analytics/`,
      },
      cache: {
        cacheLocation: 'localStorage',
      },
    };

    // eslint-disable-next-line no-undef
    msalInstance = new Msal.UserAgentApplication(msalConfig);
  };

  useEffect(() => {
    const aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = 'https://alcdn.msauth.net/lib/1.4.18/js/msal.js';
    document.head.appendChild(aScript);

    aScript.onload = () => {
      initOffice(officeSsoClientId);
    };
  }, []);

  const ssoLogin = (e) => {
    e.preventDefault();

    window.history.pushState('portal', 'Login', '/analytics/'); // force base path so url can match allowed redirect urls

    const authenticationParameters = {
      scopes: ['user.read'], // optional Array<string>
      prompt: 'select_account',
      redirectUri: `${window.location.origin}/analytics/`,
    };

    msalInstance.loginPopup(authenticationParameters)
      .then(() => {
        msalInstance.acquireTokenSilent(authenticationParameters)
          .then((response) => {
            const officeIdToken = response.accessToken;
            dispatch(events.ssoLoginUser(officeIdToken, 'office'));
          }).catch((err) => {
            console.error('acquireTokenSilent fresh err', err);
          });
      }).catch((err) => {
        if (err.name === 'InteractionRequiredAuthError') {
          msalInstance.acquireTokenPopup(authenticationParameters)
            .then((response2) => {
              const token = response2.accessToken;
              dispatch(events.ssoLoginUser(token, 'office'));
            })
            .catch((err2) => {
              console.error('acquireTokenSilent fresh err', err);
              console.error('acquireTokenPopup fresh err', err2);
            });
        } else {
          console.error('acquireTokenSilent fresh err', err);
        }      
      });
  };

  return (
    <div className={styles.ssoContainer}>
      <Button
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        className={styles.ssoBtn}
        onClick={ssoLogin}
      >
        <img src={officeLogo} alt="logo" className={styles.ssoLogo} />
        <FormattedMessage {...messages.LOG_IN_WITH_OFFICE} />
      </Button>
    </div>
  );
}

export default OfficeSso;
